import { useEffect, useState } from "react";
import toast from "react-hot-toast";

import { HiOutlineNewspaper } from "react-icons/hi";

import PreLoader from "../PreLoader/PreLoader";

import { getNewsPublicService } from "../../services/userServices";
import { isEmpty } from "lodash";

const NewsModal = ({ openModal }) => {
  const [getNews, setGetNews] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [_, setCounter] = useState(0);

  //* Handle Get Items List
  const handleGetNews = async () => {
    try {
      const { status, data } = await getNewsPublicService();
      if (status === 200) {
        setGetNews(data);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    }
  };

  //* Fetch Data
  const handleInitial = async () => {
    setCounter((prevCounter) => prevCounter + 1);
    await handleGetNews();
  };

  useEffect(() => {
    const fetchData = async () => {
      await handleInitial();
      setIsLoading(false);
    };
    fetchData();

    const interval = setInterval(handleInitial, 10000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <span
        className={` ${
          openModal
            ? "animate__animated animate__fadeInDown animate__faster"
            : "animate__animated animate__fadeOutDown animate__faster"
        } lg:absolute top-12 text-white font-normal bg-boxColor
        w-[95%] lg:h-64 h-44 overflow-y-scroll p-2 text-justify rounded-xl
        text-sm border-2 border-[#ffe6005e]
        
        `}
      >
        {isLoading ? (
          <span className="flex justify-center items-center">
            <PreLoader width={20} />
          </span>
        ) : (
          <>
            {isEmpty(getNews) ? (
              <span className="w-full flex flex-col items-center justify-center h-full text-slate-200">
                <HiOutlineNewspaper size={40} />
                <span>خبری وجود ندارد</span>
              </span>
            ) : (
              <div
                className="flex flex-col overflow-y-auto h-full
                animate__animated animate__fadeIn animate__slow"
              >
                {getNews.map((_items, index) => (
                  <div
                    key={index}
                    className={`${
                      getNews.length > 1
                        ? "border-0 border-b-[0.5px] border-slate-600 py-5 mx-5"
                        : null
                    } lg:px-0 px-8`}
                  >
                    <span className="my-3 block text-base font-bold text-center">
                      {_items?.title}
                    </span>
                    <span className="my-3 leading-loose">
                      {_items?.description}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </span>
    </>
  );
};

export default NewsModal;
